module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Media-folder-b8568d0bc46c48f67655c1b101164f7e.svg";